// ObligationLayout — category-based two-panel layout for obligation routes.
// Delegates to the shared CategoryLayout component.
// Uses 'framework' category type (obligations live under framework categories).
// Adds an "Add" button in the sidebar header that opens the import dialog.

import { useState } from 'react'
import { CategoryLayout, useSelectedCategory } from '@/components/features/category-selection-tree'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'
import { ImportFrameworkDialog } from './ImportFrameworkDialog'

// Re-export under the domain-specific name for backward compatibility
export { useSelectedCategory as useSelectedObligationCategory }

export function ObligationLayout() {
  const [importOpen, setImportOpen] = useState(false)

  return (
    <>
      <CategoryLayout
        categoryType="framework"
        domainPath="obligations"
        heading="Obligation Categories"
        headerAction={
          <Button
            size="sm"
            variant="outline"
            className="h-7 text-xs"
            onClick={() => setImportOpen(true)}
          >
            <Plus className="mr-1 h-3 w-3" />
            Add
          </Button>
        }
      />
      <ImportFrameworkDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
      />
    </>
  )
}
